import React, { PropTypes } from 'react';

import './VideoPlayback.scss';

export function VideoPlayback({ src }) {
  return (
    <iframe
      className="cp-ugc-video-playback"
      data-key="ugc-video-playback"
      src={src}
      frameBorder="0"
      allowFullScreen />
  );
}

VideoPlayback.propTypes = {
  src: PropTypes.string.isRequired
};

export default VideoPlayback;



// WEBPACK FOOTER //
// ./app/components/shared/UGC/VideoPlayback/VideoPlayback.jsx